<template>
  <EmdFormGroup
    :label="$t('phone-number')"
    :state="getState($v.recipient.phone_numbers.number)"
    :feedbacks="feedbacks($v.recipient.phone_numbers.number)"
  >
    <EmdInput
      :disabled="disabled"
      @input="() => $v.recipient.phone_numbers.number.$touch()"
      v-model="recipient.phone_numbers[0].number"
      :mask="['####-####', '#####-####']"
      name="phone-number"
    />
  </EmdFormGroup>
</template>
<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { recipientValidationsGeneral } from '../validations'

export default {
  name: 'PhoneNumberInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    number: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return { recipient: recipientValidationsGeneral }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "phone-number": "Número de telefone"
    },
    "en-US": {
      "phone-number": "Phone  number"
    }
  }
</i18n>
